import { AnyConceptStatusesByCid, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	DrugDisposalConcept,
	getConceptStatusValue,
	RDrugDisposal,
} from "@fusion-advantage/formlib"
import { FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setFormModelDrugDisposal } from "../../redux/formModelSlice"

export class DrugDisposalModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rParse = z.array(RDrugDisposal).safeParse(valueForCid(DrugDisposalConcept.cid))
		if(!rParse.success) {
			return err(serializeFusionError('DrugDisposalModelReduxPersister rParse', rParse.error))
		}
		dispatch(setFormModelDrugDisposal(rParse.data))
		return ok()
	}
	shouldSave(): boolean {
		return false
	}
	createStatusUpdates(): ConceptStatusUpdate[] {
		return []
	}
}
